module.exports = __webpack_public_path__ + "img/silence.25549271.svg";